module.exports = __webpack_public_path__ + "9f96bb98b89d7cca251fd918f5befda3.svg";